import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, UserCheck, Headphones, Gem } from 'lucide-react';
const features = [{
  icon: <ShieldCheck className="w-10 h-10" data-id="element-406" />,
  title: '严格审核认证',
  description: '所有伴游均经过严格的身份验证与面试筛选，确保真实可靠，杜绝虚假信息。'
}, {
  icon: <UserCheck className="w-10 h-10" data-id="element-407" />,
  title: '隐私安全保障',
  description: '我们采用最高级别的隐私保护措施，严格保密您的个人信息与行程安排。'
}, {
  icon: <Headphones className="w-10 h-10" data-id="element-408" />,
  title: '24/7专属客服',
  description: '全天候专属客服团队，随时为您解答疑问，处理突发状况，确保无忧体验。'
}, {
  icon: <Gem className="w-10 h-10" data-id="element-409" />,
  title: '高端精选服务',
  description: '专注于为高端人士提供高品质服务，每一个细节都经过精心打磨，尽显尊贵。'
}];
const stats = [{
  value: '500+',
  label: '认证伴游'
}, {
  value: '10k+',
  label: '满意客户'
}, {
  value: '100%',
  label: '隐私保护'
}, {
  value: '24/7',
  label: '全天候支持'
}];
export function WhyChooseUs() {
  return <section className="py-24 bg-dark-bg relative" data-id="element-410">
      <div className="container mx-auto px-4" data-id="element-411">
        <div className="text-center mb-20" data-id="element-412">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-5xl text-white mb-6" data-id="element-413">
            为什么选择我们
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-400 max-w-2xl mx-auto" data-id="element-414">
            在
            SGLonelyGuy，我们不仅仅提供伴游服务，更致力于为您打造安全、私密、高品质的社交生活方式。
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-24" data-id="element-415">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center group" data-id="element-416">
              <div className="w-20 h-20 mx-auto bg-dark-card rounded-full flex items-center justify-center text-gold-500 mb-6 group-hover:scale-110 group-hover:bg-gold-500 group-hover:text-black transition-all duration-300 shadow-lg shadow-black/50" data-id="element-417">
                {feature.icon}
              </div>
              <h3 className="text-xl font-serif text-white mb-3" data-id="element-418">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-419">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        {/* Stats Banner */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-dark-card via-[#222] to-dark-card rounded-2xl p-12 border border-white/5" data-id="element-420">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-421">
            {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-422">
                <div className="text-3xl md:text-5xl font-serif text-gold-500 mb-2 font-bold" data-id="element-423">
                  {stat.value}
                </div>
                <div className="text-gray-400 text-sm uppercase tracking-wider" data-id="element-424">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}